"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CaseChooser = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var DEFAULT_PROPS = {
    cases: [],
    chooseCase: function (caseDetail) { }
};
var CLINICAL_ID_TYPES = {
    ACCESSION_NUMBER: 'Accession'
};
var CaseChooser = function (passed) {
    var props = __assign(__assign({}, DEFAULT_PROPS), passed);
    var chooseCase = props.chooseCase, launchParams = props.launchParams;
    var handleItemClick = (0, react_1.useCallback)(function (event) {
        event.preventDefault();
        var target = event.target || document.createElement('div');
        var linkable = target === null || target === void 0 ? void 0 : target.closest('a');
        if (!linkable)
            return;
        var item = linkable.attributes.getNamedItem('data-process-instance-id');
        if (!item)
            return;
        var processInstanceId = parseInt(item.value);
        if (processInstanceId === undefined)
            return;
        var caseRun = cases.find(function (caseRun) { return caseRun.process_instance_id === processInstanceId; });
        if (caseRun) {
            chooseCase(caseRun);
        }
    }, [chooseCase]);
    var cases = passed.cases;
    var hasCases = cases.length > 0;
    var displayedCases = cases.map(function (caseRun, idx) {
        var clinicalId = caseRun.primary_clinical_identifier;
        return ((0, jsx_runtime_1.jsxs)("a", __assign({ "data-process-instance-id": caseRun.process_instance_id, className: 'case-chooser-item qa-case-chooser-item', onClick: handleItemClick }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "chase-chooser-description" }, { children: caseRun.reason_for_visit })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "case-chooser-meta" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "case-chooser-key" }, { children: [CLINICAL_ID_TYPES[clinicalId.type] || clinicalId.type, ":"] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "case-chooser-value" }, { children: ["#", clinicalId.number, " (", clinicalId.issuer, ")", ' '] }))] }))] }), idx));
    });
    var classNames = (0, classnames_1["default"])([
        "case-chooser",
        {
            'case-chooser-empty': !hasCases,
            'case-chooser-populated': hasCases
        }
    ]);
    var dateOfService = launchParams.serviceDate || 'N/A';
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(classNames) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "empty-message" }, { children: "No cases were found" })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "case-display-container" }, { children: [(0, jsx_runtime_1.jsx)("h4", { children: "Select Charge Session" }), (0, jsx_runtime_1.jsxs)("p", { children: ["Multiple results were found for ", (0, jsx_runtime_1.jsx)("b", { children: dateOfService }), ". Please select the relevant item below."] }), (0, jsx_runtime_1.jsx)("div", { children: displayedCases })] }))] })));
};
exports.CaseChooser = CaseChooser;
//# sourceMappingURL=case-chooser.js.map